import { EventIdentifier, TrackingEventType, useAnalytics } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { type WCPledgeBasketFooterProps } from '@capsicum/features/world-championship-pledge/shared';

import { useWCPledgeDisclaimerModal } from './modals/useWCPledgeDisclaimerModal';

export const useWCPledgeBasketFooterActions = ({
	formattedTotalPledgeAmount,
	variant
}: Omit<WCPledgeBasketFooterProps, 'basketLength'>) => {
	const { push } = useRouter();
	const { openWCPledgeDisclaimerModal } = useWCPledgeDisclaimerModal();
	const analytics = useAnalytics();

	const onClickHandlerLookup: Record<WCPledgeBasketFooterProps['variant'], () => void> = {
		basketDetails: () => {
			analytics.sendEvent(TrackingEventType.track, EventIdentifier.ButtonClicked, {
				action: 'wc_pledge_add_to_cart',
				chz_amount: formattedTotalPledgeAmount
			});
			openWCPledgeDisclaimerModal();
		},
		itemSelection: () => push('/locker-room-internationals/basket')
	};

	return {
		onClickHandler: onClickHandlerLookup[variant]
	};
};
